(() => {
  if (!new URLSearchParams(window.location.search).has("livechat")) {
    return;
  }

  let attempts = 0;
  const retryInterval = window.setInterval(() => {
    attempts += 1;

    if (window.ResolviaChat) {
      window.ResolviaChat.open();
      window.clearInterval(retryInterval);
    } else if (attempts >= 100) {
      window.clearInterval(retryInterval);
    }
  }, 100);
})();
